import * as noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

jQuery(document).ready(function () {

  // === FIXED COOKIE HELPERS (keep this block together) ===
    const PAWZLES_COOKIE = 'pawzles_prefs';
    const COOKIE_MAX_DAYS = 400;

    function setCookie(name, value, days)
    {
        try {
            const d = new Date();
            d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
            const expires = 'expires=' + d.toUTCString();
            const secure = location.protocol === 'https:' ? '; Secure' : '';
          // ⚠️ No spaces around '=' and attributes are consistent
            document.cookie = `${name} = ${encodeURIComponent(String(value))}; ${expires}; Path = / ; SameSite = Lax${secure}`;
        } catch (_) {
          /* noop */ }
    }

    function getCookie(name)
    {
      // More reliable parsing — no space bugs
        const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : '';
    }

  /** Always returns a plain object */
    function readPrefs()
    {
        try {
            const raw = getCookie(PAWZLES_COOKIE);
            if (!raw) {
                return }
            const parsed = JSON.parse(raw);
            return (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) ? parsed : {};
        } catch {
            return {};
        }
    }

    function writePrefs(obj)
    {
        const safe = (obj && typeof obj === 'object') ? obj : {};
        setCookie(PAWZLES_COOKIE, JSON.stringify(safe), COOKIE_MAX_DAYS);
    }

    function keyFromSelectName(name)
    {
        return String(name || '').replace(/^_weekly_challenge_/, '');
    }


  // Optional: sync UI from cookie (safety if PHP didn’t preselect for some reason)
    (function applyCookieToSelectsOnLoad()
    {
        const prefs = readPrefs();
        if (!prefs || !Object.keys(prefs).length) {
            return;
        }
        $('.challenge-pawzles select').each(function () {
            const $sel = $(this);
            const key = keyFromSelectName($sel.attr('name'));
            if (Object.prototype.hasOwnProperty.call(prefs, key)) {
                $sel.val(String(prefs[key]));
            }
        });
    })();

  // ===== Your original logic (with cookie integration) =====

    const levelTimes = pawzler_weekly_challenge_object;

    let slider = document.getElementById('weekly-time-slider');
    let sliderValues = [
    document.getElementById('weekly-time-min'),
    document.getElementById('weekly-time-max'),
    ];
    let hiddenSliderValues = [
    document.getElementById('weekly-time-min-seconds'),
    document.getElementById('weekly-time-max-seconds'),
    ];

    let timeMin = parseInt(levelTimes[0].min);
    let timeMax = parseInt(levelTimes[0].max);

    timeMin = Math.floor(timeMin / 15) * 15;
    timeMax = Math.ceil(timeMax / 15) * 15;

    noUiSlider.create(slider, {
        start: [timeMin, timeMax],
        connect: true,
        behaviour: 'drag',
        step: 15,
        margin: 15,
        range: {
            min: timeMin,
            max: timeMax,
        },
        format: {
            from: function (value) {
                return parseInt(value);
            },
            to: function (value) {
                return parseInt(value);
            },
        },
    });

    slider.noUiSlider.on('update', function (values, handle) {
        const totalSeconds = parseInt(values[handle]);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        const formatted = `${minutes}:${seconds.toString().padStart(2, '0')}`;

        sliderValues[handle].value = formatted;
        hiddenSliderValues[handle].value = totalSeconds;
    });

    slider.noUiSlider.on('change', function () {
        enable_reset_filter_button();
        enable_apply_filter_button();
    });

    let appliedFilters = collect_current_filters();

    jQuery('.challenge-level button').on('click', function () {
        const $btn = jQuery(this);
        const level = parseInt($btn.data('level'), 10);

        if (level === 0) {
          // 0 = All: exclusive selection
            setAllLevelActive();
            updateSliderForLevels([]); // reset to global
        } else {
          // Toggle this level
            $btn.toggleClass('bg-primary active');
          // If any non-zero is active, remove "All"
            jQuery('.challenge-level button[data-level="0"]').removeClass('bg-primary active');

          // If after toggling there are no non-zero selections, fall back to "All"
            const selected = getSelectedLevels();
            if (selected.length === 0) {
                setAllLevelActive();
                updateSliderForLevels([]);
            } else {
                updateSliderForLevels(selected);
            }
        }

        $btn.blur();
        enable_reset_filter_button();
        enable_apply_filter_button();
    });

    $('#weekly-challenge-reset').on('click', function () {
        setAllLevelActive();
        $('.challenge-pawzles select').val('10');

      // Rebuild prefs from current selects instead of assuming keys
        const prefs = {};
        $('.challenge-pawzles select').each(function () {
            const key = keyFromSelectName($(this).attr('name'));
            prefs[key] = 10;
        });
        writePrefs(prefs);

        slider.noUiSlider.updateOptions({
            range: { min: timeMin, max: timeMax },
            start: [timeMin, timeMax],
        });

        appliedFilters = null;
        filter_weekly_challenges({}, true);
    });


    jQuery('#weekly-challenge-apply').on('click', function () {
        appliedFilters = collect_current_filters();
        filter_weekly_challenges(appliedFilters);
    });

  // Persist cookie when any pawzle select changes (delegate so it works after moving between containers)
    $(document).on(
        'change',
        '#challenge-filters .challenge-pawzles select, #challenge-filters-mobile .challenge-pawzles select',
        function () {
            const $sel = $(this);
            const key = keyFromSelectName($sel.attr('name'));
            const val = parseInt($sel.val(), 10) || 0;

            // <-- Hardened: always use a plain object
            const current = readPrefs();
            const prefs = (current && typeof current === 'object') ? { ...current } : {};
            prefs[key] = val;                 // ✅ no more "Cannot set properties of undefined"
            writePrefs(prefs);

            enable_reset_filter_button();
            enable_apply_filter_button();
        }
    );

    jQuery('#challenge-filters .challenge-pawzles select').on('change', function () {
      // kept for compatibility; cookie write handled by delegated handler above
        enable_reset_filter_button();
        enable_apply_filter_button();
    });

    jQuery(document).on('click', '#challenge-pagination a[data-page]', function (e) {
        e.preventDefault();

        const page = parseInt(jQuery(this).data('page'));
        if (!page) {
            return;
        }

        const filters = appliedFilters
        ? { ...appliedFilters, action : 'filter_weekly_challenges', paged : page }
        : { action: 'filter_weekly_challenges', paged: page };

        filter_weekly_challenges(filters);
    });

    function getSelectedLevels()
    {
        return jQuery('.challenge-level button.active')
        .map(function () {
            return parseInt(jQuery(this).data('level'), 10);
        })
        .get()
        .filter(l => l !== 0);
    }

    function updateSliderForLevels(levels)
    {
        if (!levels || levels.length === 0) {
          // “All” – reset to global range
            slider.noUiSlider.updateOptions({
                range: { min: timeMin, max: timeMax },
                start: [timeMin, timeMax],
            });
            return;
        }

        let selMin = Infinity;
        let selMax = -Infinity;

        levels.forEach(level => {
            let min = Math.floor(parseInt(levelTimes[level].min, 10) / 15) * 15;
            let max = Math.ceil(parseInt(levelTimes[level].max, 10) / 15) * 15;
            selMin = Math.min(selMin, min);
            selMax = Math.max(selMax, max);
        });

      // Ensure at least 15s margin between handles (same as your slider config)
        const margin = 15;
        if (selMax - selMin < margin) {
            selMax = selMin + margin;
        }

        slider.noUiSlider.updateOptions({
            range: { min: selMin, max: selMax },
            start: [selMin, selMax],
            margin,
        });
    }

    function setAllLevelActive()
    {
        jQuery('.challenge-level button').removeClass('bg-primary active');
        jQuery('.challenge-level button[data-level="0"]').addClass('bg-primary active');
    }

    function filter_weekly_challenges(filters = {}, reset = false)
    {
        const $filterRoot = jQuery('[data-filter-root]');
        let data = {
            action: 'filter_weekly_challenges',
        };

        if (reset) {
            appliedFilters = null;
        }

        if (filters && Object.keys(filters).length > 0) {
            data = { ...filters, action: 'filter_weekly_challenges' };
        } else if (!reset) {
            const selectedLevels = getSelectedLevels();
            if (selectedLevels.length === 1) {
                data.level = selectedLevels[0];
            } else if (selectedLevels.length > 1) {
                data.levels = selectedLevels;
            }

            const timeMinValue = parseInt(jQuery('#weekly-time-min-seconds').val());
            const timeMaxValue = parseInt(jQuery('#weekly-time-max-seconds').val());

            if (timeMinValue !== timeMin) {
                data.time_min = timeMinValue;
            }

            if (timeMaxValue !== timeMax) {
                data.time_max = timeMaxValue;
            }

            data.pawzles = [];

            $filterRoot.find('.challenge-pawzles select').each(function () {
                data.pawzles.push({
                    name: jQuery(this).attr('name'),
                    value: jQuery(this).val(),
                });
            });
        }

        let requestStartTime = null;

        jQuery.ajax({
            url: pawzler_object.ajax,
            method: 'POST',
            data: data,
            beforeSend: function () {
                close_filter_panel();
                requestStartTime = Date.now();

                const headerHeight = jQuery('.header-main').outerHeight() || 0;
                const offset = jQuery('#weekly-challenge-items').offset().top - headerHeight - 30;

                jQuery('html, body').animate({ scrollTop: offset }, 500);

                const loader = '<div class="col-span-2 md:col-span-3 text-center"><img src="' + pawzler_object.weekly_challenge_loading_image + '" alt="Loading" class="weekly-challenge-loader mx-auto"></div>';
                jQuery('#weekly-challenge-items').html(loader);
                disable_reset_filter_button();
                disable_apply_filter_button();
            },
            success: function (response) {
                const now = Date.now();
                const elapsed = now - requestStartTime;
                const minDelay = 2000;
                const delay = Math.max(0, minDelay - elapsed);

                setTimeout(() => {
                    jQuery('#weekly-challenge-items').html(response.data);
                }, delay);
            },
            error: function () {
                const now = Date.now();
                const elapsed = now - requestStartTime;
                const minDelay = 2000;
                const delay = Math.max(0, minDelay - elapsed);
                const errorMessage = '<div class="col-span-2 md:col-span-3"><p class="text-center font-bold text-[25px]">' + pawzler_object.weekly_challenge_error_message + '</p></div>';

                setTimeout(() => {
                    jQuery('#weekly-challenge-items').html(errorMessage);
                }, delay);
            },
            complete: function () {
                enable_reset_filter_button();
            },
        });
    }

    function collect_current_filters()
    {
        const $filterRoot = jQuery('[data-filter-root]');
        const filters = {
            action: 'filter_weekly_challenges',
        };

        const selectedLevels = getSelectedLevels();
        if (selectedLevels.length === 1) {
            filters.level = selectedLevels[0];
        } else if (selectedLevels.length > 1) {
            filters.levels = selectedLevels;
        }

        const timeMinValue = parseInt(jQuery('#weekly-time-min-seconds').val());
        const timeMaxValue = parseInt(jQuery('#weekly-time-max-seconds').val());

        if (timeMinValue !== timeMin) {
            filters.time_min = timeMinValue;
        }

        if (timeMaxValue !== timeMax) {
            filters.time_max = timeMaxValue;
        }

        filters.pawzles = [];

        $filterRoot.find('.challenge-pawzles select').each(function () {
            filters.pawzles.push({
                name: jQuery(this).attr('name'),
                value: jQuery(this).val(),
            });
        });

        return filters;
    }

    function enable_reset_filter_button()
    {
        const button = jQuery('#weekly-challenge-reset');

        if (button.hasClass('opacity-50 pointer-events-none cursor-not-allowed')) {
            button.removeClass('opacity-50 pointer-events-none cursor-not-allowed');
        }
    }

    function enable_apply_filter_button()
    {
        const button = jQuery('#weekly-challenge-apply');

        if (button.hasClass('opacity-50 pointer-events-none cursor-not-allowed')) {
            button.removeClass('opacity-50 pointer-events-none cursor-not-allowed');
        }
    }

    function disable_reset_filter_button()
    {
        const button = jQuery('#weekly-challenge-reset');

        if (!button.hasClass('opacity-50 pointer-events-none cursor-not-allowed')) {
            button.addClass('opacity-50 pointer-events-none cursor-not-allowed');
        }
    }

    function disable_apply_filter_button()
    {
        const button = jQuery('#weekly-challenge-apply');

        if (!button.hasClass('opacity-50 pointer-events-none cursor-not-allowed')) {
            button.addClass('opacity-50 pointer-events-none cursor-not-allowed');
        }
    }

    jQuery('#mobile-filter-open').on('click', function () {
        jQuery('html').addClass('overflow-y-hidden');
        jQuery('#mobile-filter-panel').removeClass('hidden');

      // Force a repaint to trigger transition
        requestAnimationFrame(() => {
            jQuery('#mobile-filter-sheet')
            .removeClass('translate-y-full')
            .addClass('translate-y-0');
        });
    });

    jQuery('#mobile-filter-close').on('click', function () {
        close_filter_panel();
    });

    jQuery('#mobile-filter-panel').on('click', function (e) {
        const $target = jQuery(e.target);

        const clickedOverlay = $target.is('#mobile-filter-panel');

        if (clickedOverlay) {
            close_filter_panel();
        }
    });

    function close_filter_panel()
    {
        jQuery('html').removeClass('overflow-y-hidden');
        jQuery('#mobile-filter-sheet')
        .addClass('translate-y-full')
        .removeClass('translate-y-0');

        setTimeout(() => {
            jQuery('#mobile-filter-panel').addClass('hidden');
        }, 300);
    }

    jQuery('#mobile-filter-sheet').on('click', function (e) {
        e.stopPropagation();
    });

    function moveFiltersToCorrectContainer()
    {
        const $filterRoot = jQuery('[data-filter-root]');
        const $desktopContainer = jQuery('#challenge-filters');
        const $mobileContainer = jQuery('#challenge-filters-mobile');

        if (!$filterRoot.length) {
            return;
        }

        if (window.innerWidth < 1024) {
            if (!$mobileContainer.find('[data-filter-root]').length) {
                $mobileContainer.append($filterRoot.detach());
            }
        } else {
            if (!$desktopContainer.find('[data-filter-root]').length) {
                $desktopContainer.append($filterRoot.detach());
            }
        }
    }

    moveFiltersToCorrectContainer();

    let resizeTimeout;
    jQuery(window).on('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(moveFiltersToCorrectContainer, 100);
    });

});
